import $ from 'jquery';
import InputValidationManagerClass from '../common/InputValidationManagerClass';
import ModalBaseClass from '../../libs/modal/ModalBaseClass';
import Util from '../../libs/util/Util';

/**
 * 領収書発行モーダル
 * @example
 * <a href="" class="js-modal_receipt" data-id="8560204" data-of="航空券代金として" data-price="51920">領収書を発行</a>
 * data-id:申込番号
 * data-of:但し書き
 * data-price:金額
 * data-status:ステータス
 * にそれぞれ挿入されます
 */
export default class ReceiptModalClass extends ModalBaseClass {
  constructor() {
    super('#modal_receipt');
    this.name = 'ReceiptModalClass';
    this.data_id = '';

    this.onClickOpenListener = this.onClickOpen.bind(this);
  }

  onCreate() {
    super.onCreate();
    this.form = $('form', this._target);
    this.validation = new InputValidationManagerClass(this.form, $('button.wrap_button', this.form));
    this.validation.onCreate();
    $('.js-modal_receipt').on('click', this.onClickOpenListener);
  }

  onClickOpen(e) {
    e.preventDefault();
    const _this = $(e.currentTarget);
    const price = _this.attr('data-price') | 0;

    // エラーメッセージを消し
    for (let k in this.validation.items) {
      this.validation.items[k].errorClear();
    }
    // this.clearError();
    if (this.data_id !== _this.attr('data-id')) {
      $('.price', this.target).text(Util.numberToPrice(price));
      $('.of_text', this.target).text(_this.attr('data-of'));
      $('.data_id', this.target).val(_this.attr('data-id'));
      $('.data_status', this.target).val(_this.attr('data-status'));
      this.data_id = _this.attr('data-id');
      $(':input[name="name"]', this.form).val('');
    }
    this.onOpen();
  }
}
